

















































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import BusinessSelect from '@/components/Business/BusinessSelect.vue';
import ServiceOrderCreateServiceItemsTable from './Create/ServiceOrderCreateServiceItemsTable.vue';
import ServiceOrderCreatePaymentDetailsTable from './Create/ServiceOrderCreatePaymentDetailsTable.vue';
import ServiceOrderCreatePaymentDetailsReview from './Create/ServiceOrderCreatePaymentDetailsReview.vue';
import ServiceOrderCreateOrderDetailsReview from './Create/ServiceOrderCreateOrderDetailsReview.vue';

@Component({
  components: {
    BusinessSelect,
    ServiceOrderCreateServiceItemsTable,
    ServiceOrderCreatePaymentDetailsTable,
    ServiceOrderCreatePaymentDetailsReview,
    ServiceOrderCreateOrderDetailsReview,
  },
  computed: {
    ...mapState({
      loading: 'loading',
    }),
    ...mapState('ServiceOrder', {
      activeServiceOrder: 'activeServiceOrder',
      newBulkServiceOrder: 'newBulkServiceOrder',
    }),
    ...mapState('ServicePayment', {
      activeServicePayment: 'activeServicePayment',
    }),
    ...mapState('Business', {
      allBusinesses: 'allBusinesses',
    }),
  },
})
export default class ServiceOrderCreate extends Vue {
  currentStep = 0;
  isMounted = false;
  activeServiceOrder!: Model;
  activeServicePayment!: Model;
  newBulkServiceOrder!: ServiceOrderState['newBulkServiceOrder'];
  selectedBusiness: Model | null = null;
  loading!: boolean;

  showAdditionalService = false; //todo: need when we have additional service

  allBusinesses!: Model[];

  isApiFetch = {
    isApiFetchGstFinished: false,
    isApiFetchAllBusinessesFinished: false,
  };

  async beforeMount() {
    this.$store.commit('ServiceOrder/CLEAR_STATE');
    this.$store.commit('ServicePayment/CLEAR_STATE');

    this.$store.dispatch('Business/all').then(() => {
      this.isApiFetch['isApiFetchAllBusinessesFinished'] = true;
    });

    this.$store.dispatch('Gst/all').then(() => {
      this.isApiFetch['isApiFetchGstFinished'] = true;
    });
  }

  @Watch('isApiFetch', { deep: true })
  watchIsApiFetch(newVal) {
    if (newVal) {
      let isFinished = true;
      for (const [key, value] of Object.entries(this.isApiFetch)) {
        if (!value) {
          isFinished = false;
        }
      }
      if (isFinished) {
        this.isMounted = true;
      }
    }
  }

  get totalOrderDetailsAmount() {
    if (!this.selectedBusiness) {
      return 0;
    }
    return this.$store.getters['ServiceOrder/totalOrderDetailsAmount'](
      this.selectedBusiness.gst_rate_applied
    );
  }

  get totalPaymentDetailsAmount() {
    if (!this.selectedBusiness) {
      return 0;
    }
    return this.$store.getters['ServiceOrder/totalPaymentDetailsAmount'](
      this.selectedBusiness.gst_rate_applied
    );
  }

  get steps() {
    return [
      {
        title: 'Step 1',
        subtitle: 'Select a business',
        canProceed: () => {
          return !!this.newBulkServiceOrder.business_oid && !this.loading;
        },
      },
      {
        title: 'Step 2',
        subtitle:
          'Quescreen' +
          (this.showAdditionalService ? ' and additional services' : ''),
        canProceed: () => {
          return (
            this.newBulkServiceOrder.order_details.filter(
              (item) => item.quantity > 0
            ).length > 0 && !this.loading
          );
        },
      },
      {
        title: 'Step 3',
        subtitle: 'Client Agreement Order Details',
        canProceed: () =>
          this.totalPaymentDetailsAmount === this.totalOrderDetailsAmount &&
          this.newBulkServiceOrder.payment_details.filter(
            (item) => !item.due_date
          ).length === 0 &&
          !this.loading,
      },
      {
        title: 'Step 4',
        subtitle: 'Review',
      },
    ];
  }

  placeOrder() {
    this.$store
      .dispatch('ServiceOrder/createBulkOrder', this.newBulkServiceOrder)
      .then(() => {
        if (this.activeServiceOrder.object_id) {
          this.$router.push({
            name: 'admin-service-order-read',
            params: {
              serviceOrderOid: this.activeServiceOrder.object_id,
            },
          });
        }
      });
  }

  async navigate(from, to, done) {
    if (this.currentStep === 0) {
      await this.$store.dispatch(
        'ServiceItem/serviceItemTotalAvailableQuantity',
        this.newBulkServiceOrder.business_oid
      );
    }
    this.currentStep = to;
    done();
  }

  @Watch('newBulkServiceOrder', { deep: true })
  watchNewBulkServiceOrder(v) {
    if (v && v.business_oid) {
      this.selectedBusiness =
        this.allBusinesses.find((bus) => bus.object_id == v.business_oid) ||
        null;
    }
  }

  getUnitPriceByCountry(serviceItem) {
    if (!this.selectedBusiness) {
      return serviceItem.unit_price['AU'];
    }
    return (
      serviceItem.unit_price[this.selectedBusiness.country || 'AU'] ||
      serviceItem.unit_price['AU']
    );
  }
}
